module.exports = __webpack_public_path__ + "img/mkt.ff518420.png";